module.exports = __webpack_public_path__ + "static/media/logo_ipst.a4a21bf5.svg";